import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Box, Checkbox, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchFilter from '@ui/components/Button/SearchFilter';
const MoveToVehicleMini = ({ options, selectedVehicleIds = [], onSelect, onSearchChange }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState('');
    const filteredOptions = useMemo(() => {
        const query = searchValue.trim().toLowerCase();
        if (!query)
            return options;
        return options.filter((option) => option.vehicleNumber.toLowerCase().includes(query));
    }, [options, searchValue]);
    const handleSearchChange = (value) => {
        setSearchValue(value);
        onSearchChange?.(value);
    };
    return (_jsxs(Box, { sx: {
            width: 280,
            maxHeight: 340,
            borderRadius: 2,
            bgcolor: theme.palette.background.paper
        }, children: [_jsx(Box, { sx: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    px: 1,
                    pt: 0.5,
                    pb: 1,
                    bgcolor: theme.palette.background.paper
                }, children: _jsx(SearchFilter, { fullWidth: true, forceDesktopVariant: true, searchValue: searchValue, onSearchChange: handleSearchChange, placeholder: t('events.eventDetails.transportTab.searchVehicles'), onClear: () => handleSearchChange(''), showFilterClearButton: false, bgVariant: 'grey8' }) }), _jsxs(Box, { sx: { px: 1.5, pb: 1.5, pt: 0.5, maxHeight: 260, overflowY: 'auto' }, children: [filteredOptions.map((option) => (_jsxs(Box, { onClick: () => onSelect(option), sx: {
                            display: 'flex',
                            gap: 1,
                            py: 1,
                            cursor: 'pointer'
                        }, children: [_jsx(Box, { display: 'flex', children: _jsx(Checkbox, { disableRipple: true, checked: selectedVehicleIds.includes(option.id), size: 'small', sx: { mt: -0.4 } }) }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, children: [_jsx(Typography, { variant: 'body2', children: option.vehicleNumber }), _jsx(Typography, { variant: 'caption', color: 'text.secondary', children: `${option.seatingCapacity.consumed}/${option.seatingCapacity.total}` })] })] }, option.id))), filteredOptions.length === 0 && (_jsx(Typography, { variant: 'caption', color: 'text.secondary', children: t('dataGrid.noResults') }))] })] }));
};
export default MoveToVehicleMini;
